namespace $.$$ {
	export class $shm_hitalama_textarea extends $.$shm_hitalama_textarea {

		@ $mol_mem
		syntax() {
			return new $mol_syntax2({
				'hitalama-value': RegExp( "(?:(?:\\$" + "(?:value|widget|data|bind_value))|map\\.widget)\\s*\\(\\s*'([^'\\r\\n]*)'\\s*\\)" ),
				... this.$.$mol_syntax2_md_code.lexems,
			})
		}

		value_click( id: string, event?: MouseEvent ) {
			return event ?? null
		}

	}

	export class $shm_hitalama_textarea_code_line extends $.$shm_hitalama_textarea_code_line {

		Token( path: number[] ) {
			return this.token_type( path ) === 'hitalama-value' ? this.Token_value( path ) : super.Token( path )
		}

		token_value_click( path: number[], event?: MouseEvent ) {
			if( !event ) return null
			if( !event.ctrlKey ) return null

			event.preventDefault()
			event.stopPropagation()

			return this.value_click( this.token_value_id( path ), event )
		}

		token_value_id( path: number[] ) {
			const parent = path.slice( 0, -1 )
			const index = path[ path.length - 1 ]
			return ( this as any ).tokens( parent )[ index ].chunks[0] ?? ''
		}

	}
}
